import { isEmpty } from "lodash";
import { Carrier } from "./Carrier";
import { Company } from "./Company";
import { Validate } from "./Validate";
import { getDictionary } from "../utilities/utilities";
import { CarrierConfiguration } from "./CarrierConfiguration";
import moment from "moment";

const dictionary = getDictionary();

export interface Contract {
  id: string;
  owner: Company;
  ownerId: string;
  name: string;
  description: string;
  shipmentType: string; // [ EXPRESS, EXPRESS_RETURN, POSTAL ]
  validityFrom: Date;
  validityTo: Date;
  externalReference: string;
  active: boolean;
  type: string; // [ACTIVE, PASSIVE]
  carrierCode: string;
  totalServices: number;
  carrierConfigurationId: string;
  carrier: Carrier;
  carrierConfiguration?: CarrierConfiguration;
}

export interface CreateContract {
  name: string;
  description?: string;
  shipmentType: string; // [ EXPRESS, EXPRESS_RETURN, POSTAL ]
  validityFrom: Date;
  validityTo: Date;
  externalReference?: string;
  active?: boolean;
  type: string; // [ACTIVE, PASSIVE]
  carrierCode: string;
  totalServices?: number;
  carrierConfigurationId: string;
}

export interface UpdateContract extends CreateContract {
  id: string;
  ownerId: string;
}

export type ClonedContract = Omit<UpdateContract, "id">;

export const defaultContract: Partial<Contract> = {
  active: true,
};

const convertedContract = (contract: Contract) => ({
  name: contract.name,
  description: contract.description,
  shipmentType: contract.shipmentType,
  validityFrom: contract.validityFrom,
  validityTo: contract.validityTo,
  externalReference: contract.externalReference,
  active: contract.active,
  type: contract.type,
  carrierCode: contract.carrierConfiguration?.carrierCode || "",
  totalServices: contract.totalServices,
  carrierConfigurationId: contract.carrierConfiguration?.id || "",
});

export const convertContractToCreate = (contract: Contract): CreateContract => {
  return {
    ...convertedContract(contract),
  };
};

export const convertContractToUpdate = (contract: Contract): UpdateContract => {
  return {
    ...convertedContract(contract),
    id: contract.id,
    ownerId: contract.ownerId,
  };
};

export const convertContractToCloned = (contract: Contract): ClonedContract => {
  return {
    ...convertedContract(contract),
    ownerId: contract.ownerId,
  };
};

export const validate = (contract: Contract): Validate => {
  const validate: Validate = { isValid: true, errors: {} };

  if (!contract.name) {
    validate.errors.name = dictionary.messages.mandatory_field;
  }

  if (!contract.carrierConfiguration) {
    validate.errors.carrierConfiguration = dictionary.messages.mandatory_field;
  }

  if (!contract.validityFrom) {
    validate.errors.validityFrom = dictionary.messages.mandatory_field;
  }

  if (!contract.validityTo) {
    validate.errors.validityTo = dictionary.messages.mandatory_field;
  }

  if (moment(contract.validityFrom).isAfter(moment(contract.validityTo))) {
    validate.errors.validityTo =
      dictionary.messages.it_must_be_next_to +
      " " +
      moment(contract.validityFrom).format("DD/MM/YYYY");
  }

  if (!contract.shipmentType) {
    validate.errors.shipmentType = dictionary.messages.mandatory_field;
  }

  if (!contract.type) {
    validate.errors.type = dictionary.messages.mandatory_field;
  }

  if (!isEmpty(validate.errors)) {
    validate.isValid = false;
  }
  return validate;
};
